import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {publishReplay, refCount, switchMap} from 'rxjs/operators';
import {GlobalData} from '../model';
import {AppAuthService} from '../common/auth/app-auth.service';

@Injectable({providedIn: 'root'})
export class GlobalResolver {

  private global$_: Observable<GlobalData>;

  constructor(private http: HttpClient, private authService: AppAuthService) {
  }

  get global$() {
    if (this.global$_ == null) {
      this.global$_ = this.authService.user$.pipe(
        switchMap(user => {
          // Only fetch global data if user is authenticated
          if (user) {
            return this.http.get<GlobalData>('/api/global');
          } else {
            // Return empty data if not authenticated
            return of({} as GlobalData);
          }
        }),
        publishReplay(1),
        refCount()
      );
      setTimeout(() => this.global$_ = null, 10000);
    }
    /*
    if (this.global$_ == null) {
      this.global$_ = timer(0, 300_000).pipe(
        switchMap(() => this.http.get<GlobalData>('/api/global')),
        shareReplay(1)
      );
    }
    */
    return this.global$_;
  }

  resolve() {
    return this.global$;
  }
}
